var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 14,
    viewBox: "0 0 62 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15265_52093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6156 5.95168L35.3424 7.67774H38.2855L37.9258 9.94861H34.9837L34.3418 13.9998H31.6592L33.2949 3.68018H39.221L38.8591 5.95168H35.6156Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.819 13.9998H39.1367L40.7712 3.68018H43.4538L41.819 13.9998Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7725 5.95168L47.499 7.67774H50.5241L50.1653 9.94861H47.1399L46.8571 11.727H50.0469L49.6875 13.9998H43.8145L45.4502 3.68018H51.3208L50.9617 5.95168H47.7725Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1824 5.95168H55.8121C57.5359 5.95168 58.5898 6.99249 58.2959 8.84014C57.9796 10.8503 56.4712 11.727 54.8702 11.727H54.2683L55.1824 5.95168ZM51.2256 13.9998H55.0311C57.8899 13.9998 60.6284 11.7423 61.0893 8.84014C61.5492 5.93924 59.5381 3.68018 56.6636 3.68018H52.8597L51.2256 13.9998Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3145 5.95168L14.0419 7.67774H17.0661L16.7077 9.94861H13.6826L13.4001 11.727H16.5909L16.2296 13.9998H10.3574L11.9925 3.68018H17.8644L17.505 5.95168H14.3145Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7725 5.72751H22.0329C22.9091 5.72751 23.8691 5.89157 23.691 7.01375C23.5142 8.13658 22.5018 8.30032 21.6263 8.30032H21.3656L21.7725 5.72751ZM23.7887 9.76497C25.2952 9.50485 26.2843 8.27287 26.5087 6.85034C26.8576 4.64682 25.4647 3.67432 23.4258 3.67432H19.4145L17.7812 13.9942H20.4655L21.0923 10.0254H21.1198L23.023 13.9942H26.3632L23.7887 9.76497Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6715 13.9998H26.9873L28.6227 3.68018H31.3054L29.6715 13.9998Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3021 0L9.72222 2.62227L5.22374 10.3246L4.92771 7.09423L4.69557 3.58245H0.0467109L0 3.85957C1.19338 3.85957 1.89939 4.46673 2.0958 5.70978L2.99906 13.8981L3.00469 13.8799L3.01679 14H6.21311L11.9253 2.31749L13.125 0H11.3021Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80782 6.89225H6.02146L10.666 0L2.625 2.06768V2.28558L5.80782 3.44613V6.89225Z",
    fill: "#FD853A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15265_52093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.1549,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified2);
export default __webpack_public_path__ + "static/media/verified_2.9b2b225acafc7eb2ef1915aeea017bfa.svg";
export { ForwardRef as ReactComponent };